import ButtonFill from '@components/ButtonFill';
import Image from '@components/Image';
import Likes from '@components/Likes';
import {actions, store} from '@components/Test/Context';
import {BINARY} from '@constants/test';
import type {ReactElement} from 'react';
import {useContext} from 'react';
import {localize} from '@services/i18n';
import I18n from '@components/I18n';

interface Props {
    maxScore?: number;
    title?: string;
    image?: string;
    color: string;
    text?: string;
    link: string;
}

export default function Result(props: Props): ReactElement<Props> {
    const {currentState, dispatch} = useContext(store);

    function handleRestart() {
        dispatch({type: actions.reset});
    }

    return (
        <div className="test-result" style={{backgroundColor: props.color}}>
            {currentState.type === BINARY && (
                <div className="test-result__score">
                    {currentState.score}/{props.maxScore ?? 0}
                </div>
            )}
            {props.title ? <div className="test-result__title">{props.title}</div> : null}
            {props.image ? (
                <div className="test-result__image-container">
                    <Image src={props.image} className="test-result__image" />
                </div>
            ) : null}
            {props.text ? (
                <div className="test-result__text" dangerouslySetInnerHTML={{__html: props.text}} />
            ) : null}
            <div className="test-result__line" />
            <div className="test-result__socials">
                <div className="test-result__socials-label">{localize('Test_shareResult')}</div>
                <Likes
                    classes="js-track_test_like"
                    link={props.link}
                    title={props.title}
                    isHorizontal
                />
            </div>
            <ButtonFill type="button" className="test-result__button" onClick={handleRestart}>
                <I18n code="Test_testAgain" />
            </ButtonFill>
        </div>
    );
}
